/**
 * Keyboard module - handles keyboard shortcuts
 */

export class KeyboardHandler {
  constructor(onNumberKey, onEnterKey, onBackspaceKey) {
    this.onNumberKey = onNumberKey;
    this.onEnterKey = onEnterKey;
    this.onBackspaceKey = onBackspaceKey;
    this.enabled = false;
  }

  /**
   * Initialize keyboard event listeners
   */
  init() {
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    document.addEventListener('keyup', this.handleKeyUp.bind(this));
  }

  /**
   * Enable keyboard shortcuts
   */
  enable() {
    this.enabled = true;
  }

  /**
   * Disable keyboard shortcuts
   */
  disable() {
    this.enabled = false;
  }

  /**
   * Handle keydown events (for backspace)
   * @param {KeyboardEvent} e
   */
  handleKeyDown(e) {
    if (!this.enabled) return;

    // Prevent backspace if not in input field
    if (e.key === 'Backspace' && !this.isInputField(e.target)) {
      e.preventDefault();
      this.onBackspaceKey();
    }
  }

  /**
   * Handle keyup events (for numbers and enter)
   * @param {KeyboardEvent} e
   */
  handleKeyUp(e) {
    if (!this.enabled) return;

    // Ignore if typing in input field
    if (this.isInputField(e.target)) return;

    const key = e.key;

    // Number keys (0-9)
    if (/^[0-9]$/.test(key)) {
      e.preventDefault();
      this.onNumberKey(key);
    }
    // Enter key
    else if (key === 'Enter') {
      e.preventDefault();
      this.onEnterKey();
    }
  }

  /**
   * Check if target is an input field
   * @param {Element} element
   * @returns {boolean}
   */
  isInputField(element) {
    return (
      element.tagName === 'INPUT' ||
      element.tagName === 'TEXTAREA' ||
      element.isContentEditable
    );
  }
}
